<template>
  <button
    v-if="collectionIcon"
    type="button"
    class="btnCollection"
    @click.stop="$emit('click')">
    <img
      :src="isActive ? collectionIcon.active : collectionIcon.default"
      alt=""
      :style="{ width: collectionIcon.size }">
  </button>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    collectionIcon () {
      const setting = this.$store.getters['collection/getMyCollectionSetting']
      const scrapIcon = setting && setting.scrapIcon

      if (!scrapIcon) return null

      return {
        ...scrapIcon,
        size: `${scrapIcon.size}px`
      }
    }
  }
}
</script>